export default __webpack_public_path__ + "static/media/component_beeper.d5f6e5a1.png";